/** Where "Start My Free Trial" / "Try Joble Now" signup sends the visitor. */
export const SIGNUP_URL = "https://app.joble.app/auth/create-account?free=true";

/** Where "Book a Demo" (demo booking) sends the visitor. */
export const BOOK_DEMO_URL =
  "https://joble.app.joble.app/booking/ddb49077-6fc5-4d5e-9d77-2dc485e2fd04";

export interface Benefit {
  icon: string;
  title: string;
  description: string;
  /** The product block on the Products page this benefit links to. */
  productId: string;
  productName: string;
}

export const BENEFITS: Benefit[] = [
  {
    icon: "ri-question-answer-line",
    title: "Answer customer questions",
    description: "Let Sofia respond using information about the business.",
    productId: "web-agent",
    productName: "AI Web Agent",
  },
  {
    icon: "ri-time-line",
    title: "Stay available when your team isn't",
    description:
      "Experience how customer conversations can continue outside normal working hours.",
    productId: "phone-agent",
    productName: "AI Phone Agent",
  },
  {
    icon: "ri-dashboard-line",
    title: "Joble Workspace ties it together",
    description:
      "Joble Workspace keeps your whole team organized and in sync, so every chat, call and booking lives in one shared place.",
    productId: "workspace",
    productName: "Joble Workspace",
  },
];